<i matTooltip="Copy link"
   (click)="$event.stopPropagation()"
   [cdkCopyToClipboard]="this.data ? this.data : ''"
   class="fa-sharp fa-link-simple mg-l-s copy-link-icon"></i>
